import PropTypes from 'prop-types';
import React from 'react';

import { PressCarousel } from '../../../components/insurancesCarousel/InsurancesCarousel';

import './pressSection.scss';

export default function PressSection(props) {
  const { title } = props;

  return (
    <section id="press" className="press">
      <div className="title-container">
        <p className="overline salmon">{title}</p>
      </div>

      <PressCarousel />
    </section>
  );
}

PressSection.propTypes = {
  title: PropTypes.string.isRequired,
};
